/**
 * Created by minimus on 20.03.2015.
 */

(function() {
  document.addEventListener('DOMContentLoaded', () => {
    const lineStyle = document.querySelector('#l_style');
    const helpers = document.querySelectorAll('.cnt-helper');
    [...helpers].forEach(el => el.addEventListener('click', event => {
      const target = event.currentTarget;
      switch (target.id) {
        case 'line-center':
          lineStyle.textContent = "display: flex; justify-content: center; align-items: center;";
          break;
        case 'line-left':
          lineStyle.textContent = "display: flex; justify-content: start; align-items: start;";
          break;
        case 'line-right':
          lineStyle.textContent = "display: flex; justify-content: end; align-items: end;";
          break;
        default: break;
      }
    }));
  });
})();